<template>
  <div class="admin-form-item" :style="backgroundStyle"
       :class="{ 'flex-item' : isFlex, 'flex-align-item' : isFlexAlign }">

    <!-- 제목 -->
    <div class="form-header" :style="formHeaderStyle">
      <slot name="title"></slot>
      <div class="flex">
        <!-- 레이블 -->
        <label v-if="label"
              class="label" :style="labelStyle">
          {{ label }}
          <span v-if="notRequired">(선택사항)</span>
        </label>

        <tool-tip style="margin-left:4px"
                  icon="help_outline"
                  :text="tip" :textPrimary="primaryTip" v-if="tip"/>
        <link-icon :link="link" v-if="link"></link-icon>

        <!-- 팁 내용 -->
        <div class="tip">
          <!--<i class="material-icons help-icon" @mouseover="selectedHelp=true" @mouseleave="selectedHelp=false">help_outline</i>-->
          <!--<div class="help-outside" @click="clickOutSide" v-if="selectedHelp"></div>-->
          <!--<div class="tip-desc" v-if="selectedHelp" :style="`width:${computedWidth}px;left:${computedLeft}px`">{{ tip }}</div>-->
        </div>


        <!-- 설명 -->
        <div v-show="desc"
            class="description" :style="descStyle">{{ desc }}</div>

        <slot name="desc2"></slot>
        <slot name="button"></slot>
      </div>
    </div>

    <!-- 컨텐츠 -->
    <div class="content" :class="{ 'flex-content' : isFlex }"><slot></slot></div>

  </div>
</template>

<script>
  import ToolTip from "../common/ToolTip";
  import LinkIcon from "../common/LinkIcon";
  export default {
    components: {LinkIcon, ToolTip},
    props: {

      // 레이블
      label: {
        type: String,
        required: false
      },

      // 설명 (레이블 옆에 위치)
      desc: {
        type: String,
        required: false
      },

      // 정보 및 주의사항 (컨텐츠 밑에 위치)
      tip: {
        type: String,
        required: false
      },

      // primary color 정보 및 주의사항 (컨텐츠 밑에 위치)
      primaryTip: {
        type: String,
        required: false
      },

      link: {
        type: String,
        required: false
      },

      // 선택사항일 경우
      notRequired: {
        type: Boolean,
        required: false,
        dafault: false
      },

      isFlex: {
        type: Boolean,
        default: false,
        required: false
      },


      isFlexAlign: {
        type: Boolean,
        default: false,
        required: false
      },

      justifyContent: {
        type: String,
        defalut: false,
        required: false
      },

      background: {
        type: Boolean,
        default: false,
        required: false
      },

      isHeaderBlock: {
        type: Boolean,
        default: false,
        required: false
      },

      customLabelStyle: {
        type: Object,
        required: false
      },

      customHeaderStyle: {
        type: Object,
        required: false
      }

    },

    data() {
      return {
        selectedHelp: true
      }
    },

    computed: {
      computedWidth() {
        if(this.isMobile) {
          return 300
        } else if (this.tip) {
          return this.tip.length*11
        }
      },
      computedLeft() {
        if(this.isMobile) {
          return 140
        } else if (this.tip) {
          return (this.tip.length*11)/12
        }
      },
      backgroundStyle() {
        let styles = '';
        if( this.background )
          styles = 'background-color: #eee; border-radius: 3px;';
        if( this.justifyContent ) {
          styles += `justify-content: ${this.justifyContent};`
        }

        return styles;
      },
      formHeaderStyle() {
        if (this.isHeaderBlock) {
          return 'display: block !important;';
        } else if (this.customHeaderStyle) {
          return this.customHeaderStyle;
        }
      },
      descStyle() {
        if (this.isHeaderBlock) {
          return 'padding-left: 0 !important;';
        }
      },
      labelStyle() {
        if(this.customLabelStyle) {
          return this.customLabelStyle
        }

        if (this.isHeaderBlock) {
          return 'margin-bottom: 0 !important;';
        }
      }
    },

    methods: {
      clickOutSide() {
        this.selectedHelp = false;
      }
    }

  }
</script>

<style lang="stylus" type="stylus" scoped>

  .flex-item
  .flex-align-item
    display flex
    flex-wrap wrap
    gap 8px 16px
    .label
      margin-bottom 0
      word-break keep-all

  .flex-align-item
    align-items center

  .flex-content
    font-size 14px

  .form-header
    position relative

  .description
    font-size .7rem
    flex 1
    padding-left 12px
    padding-top 1px
    color #989898
    margin-bottom 0.5em
    white-space pre-wrap


  .tip
    /*text-align end*/
    font-size .8rem
    padding-top 2px
    position relative

  .tip2
    font-size

  .admin-form-item
    margin-bottom 12px

  .admin-form-item:last-child
    margin-bottom 0

  .help-outside
    position fixed
    top 0
    left 0
    right 0
    bottom 0
    z-index 120
    background rgba(0,0,0, 0.3)

  .help-icon
    font-size 16px
    cursor pointer

  .tip-desc
    position absolute
    z-index 125
    top -75px
    background-color white
    box-shadow 0 4px 4px rgba(0, 0, 0, 0.25)
    border-radius 4px
    width 320px
    padding 20px
    font-size 14px
    color #000000
    white-space pre-line
    line-height 18px
  .content
    flex 1

</style>
<style lang="stylus">
  .admin-form-item .label
    font-size 13px
</style>
